// "Ask Reggie" launcher placed in the header of each Analytics page.
// Renders nothing unless the organization has isRhinoAnalystEnabled (CCR
// toggle), the service URL is configured, and the user can view analytics.

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import cx from 'classnames';

import { isAskReggieAvailable } from './RhinoAnalystDrawer';
import {
  clearAskReggieContext, getAskReggieState, setAskReggieContext, toggleAskReggie,
} from '../reducers/rhinoanalystReducer';
import { getCurrentOrg } from '../selectors/organizationSelectors';
import { userHasAnyOfPermissions } from '../helpers/UserHelpers';
import { ANALYTICS_VIEW } from '../constants/UserPermissionsConstants';
import askReggieImage from '../assets/images/rhinoanalyst/ask-rhino.png';

const AskReggieButton = ({ className, page }) => {
  const dispatch = useDispatch();
  const currentOrganization = useSelector(getCurrentOrg);
  const { isOpen } = useSelector(getAskReggieState);

  // Pages that do not publish their own filters (see RhinoVOIPReports) still tell
  // Reggie which report the user is looking at.
  useEffect(() => {
    if (!page) return undefined;
    dispatch(setAskReggieContext({ page, label: page }));
    return () => dispatch(clearAskReggieContext());
  }, [dispatch, page]);

  if (!isAskReggieAvailable(currentOrganization) || !userHasAnyOfPermissions([ANALYTICS_VIEW])) {
    return null;
  }

  return (
    <button
      type="button"
      className={cx('rhinoanalyst-launcher', className, { 'is-active': isOpen })}
      onClick={() => dispatch(toggleAskReggie())}
      data-cypress="askReggieButton"
      title="Ask Reggie, your analytics assistant"
    >
      <img src={askReggieImage} alt="" />
      <span>Ask Reggie</span>
    </button>
  );
};

AskReggieButton.propTypes = {
  className: PropTypes.string,
  page: PropTypes.string,
};

AskReggieButton.defaultProps = {
  className: '',
  page: null,
};

export default AskReggieButton;
